export class TierDto {
  id: string;
  fixValue: number;
  perValue: number;
  threshold: number;
  order: number;
  bhnGetsPays = false;

  constructor(d?: TierDto | null) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.fixValue = d.fixValue;
    this.perValue = d.perValue;
    this.threshold = d.threshold;
    this.order = d.order;
    this.bhnGetsPays = d.bhnGetsPays;
  }
}
